// @flow
import React from 'react';
import Spinner from 'components/atoms/Spinner';
import ParseHTML from 'components/atoms/ParseHTML';
// eslint-disable-next-line import/named
import { injectIntl, type IntlShape } from 'react-intl';
import './LoadingAppointment.scss';

type Props = {
  intl: IntlShape
};

class LoadingAppointment extends React.Component<Props> {
  static block = 'loading-appointment';
  render() {
    const { intl } = this.props;
    const ns = LoadingAppointment.block;
    return (
      <div className={ns}>
        <div className={`${ns}__wrapper`}>
          <div className={`${ns}__title`}>
            <ParseHTML
              html={intl.formatMessage({
                id:
                  'c8.loading.appointment.redirecting.to.the.scheduling.experience'
              })}
            />
          </div>
          <div>
            <Spinner
              className={`${ns}__spinner`}
              classNameCircle={`${ns}__spinner--circle`}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(LoadingAppointment);



// WEBPACK FOOTER //
// ./src/components/atoms/Mask/LoadingAppointment.js